export default (state, { payload: { isAuthenticated } }) => ({
  ...state,
  isAuthenticated
});
